import { render, staticRenderFns } from "./OrderForSeniorCustomerData.vue?vue&type=template&id=a143cad6&scoped=true&"
import script from "./OrderForSeniorCustomerData.vue?vue&type=script&lang=js&"
export * from "./OrderForSeniorCustomerData.vue?vue&type=script&lang=js&"
import style0 from "./OrderForSeniorCustomerData.vue?vue&type=style&index=0&id=a143cad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a143cad6",
  null
  
)

export default component.exports